import { Injectable, Inject } from "@angular/core";
import { DataService } from "../data.service";
import { ScheduleTaskSearchItem } from "../../model/schedule-task/schedule-task-search-item";

@Injectable({
  providedIn: "root",
})
export class ScheduleTaskService {
  constructor(
    @Inject("BASE_URL") private baseUrl: string,
    private dataService: DataService
  ) {}

  private readonly scheduleTaskCreateEndPoint: string =
    "/scheduleTask/scheduleTaskCreate/";
  private readonly getScheduleTaskSearchItemEndPoint: string =
    "/scheduleTask/getScheduleTaskSearchItem/";
  private readonly getScheduleTaskResponseEndPoint: string =
    "api/FileDownloading/download/";

  getScheduleTaskResponseLink(
    scheduleTaskSearchItem: ScheduleTaskSearchItem
  ): string {
    let downloadUrl = "";
    if (scheduleTaskSearchItem.UrlDownloadBase) {
      downloadUrl =
        scheduleTaskSearchItem.UrlDownloadBase +
        "?id=" +
        scheduleTaskSearchItem.Id +
        "&name=" +
        scheduleTaskSearchItem.Name.replace(/\s/g, "")
          .replace("/", "")
          .replace(".", "");
    } else {
      downloadUrl =
        this.baseUrl +
        this.getScheduleTaskResponseEndPoint +
        scheduleTaskSearchItem.Id +
        "/" +
        scheduleTaskSearchItem.Name.replace(/\s/g, "")
          .replace("/", "")
          .replace(".", "");
    }

    return downloadUrl;
  }

  async getScheduleTaskSearchItem(): Promise<ScheduleTaskSearchItem[]> {
    const params = {};
    return await this.dataService
      .get<ScheduleTaskSearchItem[]>(
        this.getScheduleTaskSearchItemEndPoint,
        params
      )
      .toPromise();
  }

  async scheduleTaskCreate(
    scheduledTaskTypeId: number,
    date: Date,
    hour: number,
    minute: number,
    name: string,
    parameters: string
  ): Promise<boolean> {
    const params = {
      ScheduledTaskTypeId: scheduledTaskTypeId,
      Date: new Date(
        date.getFullYear(),
        date.getMonth(),
        date.getDate()
      ).toDateString(),
      Hour: hour,
      Minute: minute,
      Name: name,
      Parameters: parameters,
    };
    return await this.dataService
      .post<boolean>(this.scheduleTaskCreateEndPoint, params)
      .toPromise();
  }
}
